import { getDefaultGroup, getMatchedGroupId } from '@/components/sidebar/utils';
import useLayout from '@/composables/useLayout';
import { shallowObj } from '@/utils/object';
import { defineContext } from '@/utils/vue/context';
import { computed, inject } from '@vue/composition-api';
import { cloneDeep, noop } from 'lodash';
import { Mode } from '../type';
import { getMenuItems } from '../util';
import { useSyncToStore } from './useSyncToStore';
import { useAutoUpdateGroupId } from './useUpdateGroupId';
import { useBaseInfo } from './useBaseInfo';
function useContext({ formatter }) {
    const wLayout = inject('wLayout');
    const { visibleSidebarGroups, sidebarTheme, biz, roles, project, isAdmin, visibleGroupMap, curGroup } = useLayout();
    const { options } = useBaseInfo();
    const getGroupId = () => getMatchedGroupId(visibleSidebarGroups.value, options.value) || getDefaultGroup()?.groupId;
    useAutoUpdateGroupId();
    const groupId = computed(getGroupId);
    const sidebar = computed(() => {
        // 触发依赖收集
        noop(biz.value, roles.value, isAdmin.value);
        return formatter.sidebar({ groupId: groupId.value, sidebarMap: visibleGroupMap.value, origin: visibleSidebarGroups.value }) ?? {};
    });
    const menus = computed(() => getMenuItems(formatter.menus(cloneDeep(shallowObj({ sidebar })))));
    const groupInfo = computed(() => shallowObj({ groupId, sidebar, menus }));
    const menusMap = computed(() => {
        const map = {};
        const walk = (menus) => menus?.forEach((m) => {
            map[m.key] = m;
            walk(m.args.menus);
        });
        walk(menus.value);
        return map;
    });
    const getMenu = (val) => menusMap.value[String(val)];
    useSyncToStore(Mode.Runtime);
    const isDarkTheme = computed(() => sidebarTheme.value === 'dark');
    const currentGroupId = computed(() => curGroup.value?.groupId);
    return { sidebar, wLayout, sidebarTheme, project, options, menus, getMenu, isDarkTheme, currentGroupId, groupInfo };
}
export const [provideSidebarContext, mountSidebarContext, getSidebarContext] = defineContext(useContext);
